import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import '../pages.css';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      const next = await login(username, password);
      // Admins go to the admin panel; everyone else goes straight to videos.
      navigate(next.role === 'admin' ? '/admin' : '/videos', { replace: true });
    } catch (err) {
      if (err && err.status === 401) {
        setError('用户名或密码错误');
      } else if (err && err.status === 429) {
        setError('尝试次数过多，请稍后再试');
      } else {
        setError((err && err.message) || '登录失败');
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="page page-center">
      <form className="card form-card" onSubmit={onSubmit}>
        <Link to="/" className="back-link">← 返回首页</Link>
        <h1>登录</h1>
        <label>用户名</label>
        <input value={username} onChange={(e) => setUsername(e.target.value)} autoComplete="username" required />
        <label>密码</label>
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" required />
        {error && <p className="error">{error}</p>}
        <button type="submit" disabled={busy}>{busy ? '登录中…' : '登录'}</button>
      </form>
    </div>
  );
}
